var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    style: {
      fill: "#FF4B55"
    },
    width: 256,
    height: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#4173CD"
    },
    width: 256,
    height: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M131.4,90.349l8.416,25.234l26.6,0.206c3.444,0.027,4.872,4.422,2.101,6.467l-21.398,15.802   l8.024,25.361c1.039,3.283-2.7,6-5.501,3.997L128,151.949l-21.641,15.468c-2.802,2.003-6.54-0.714-5.501-3.997l8.024-25.361   l-21.398-15.802c-2.77-2.046-1.342-6.441,2.101-6.467l26.6-0.206l8.416-25.234C125.689,87.082,130.311,87.082,131.4,90.349z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M387.4,346.349l8.416,25.234l26.6,0.206c3.444,0.027,4.872,4.422,2.101,6.467l-21.398,15.802  l8.024,25.361c1.039,3.283-2.7,6-5.501,3.997L384,407.949l-21.641,15.468c-2.802,2.003-6.54-0.714-5.501-3.997l8.024-25.361  l-21.398-15.802c-2.77-2.046-1.342-6.441,2.101-6.467l26.6-0.206l8.416-25.234C381.689,343.082,386.311,343.082,387.4,346.349z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPa);
export default __webpack_public_path__ + "static/media/PA.99777f8cd31ef597ec41f8fbab65e86b.svg";
export { ForwardRef as ReactComponent };